import { render } from "./Form.vue?vue&type=template&id=58cbe2bc&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=58cbe2bc&scoped=true&lang=css"

import exportComponent from "/Users/mac_2/workspace/jukebox-goass/_neu/goass-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cbe2bc"]])

export default __exports__